/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdvisorChatMessageRequest } from '../models';
// @ts-ignore
import { AdvisorChatMessageResponse } from '../models';
// @ts-ignore
import { AdvisorChatSessionResponse } from '../models';
// @ts-ignore
import { AdvisorChatSessionsResponse } from '../models';
// @ts-ignore
import { AdvisorChatSubjectTypeEnum } from '../models';
// @ts-ignore
import { AdvisorQuestionSuggestionResponse } from '../models';
/**
 * AdvisorChatApi - axios parameter creator
 * @export
 */
export const AdvisorChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new advisor chat session for the patient with an initial message
         * @param {number} patient_id 
         * @param {AdvisorChatMessageRequest} AdvisorChatMessageRequest 
         * @param {string} [session_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiCreatePatientAdvisorChatSession: async (patient_id: number, AdvisorChatMessageRequest: AdvisorChatMessageRequest, session_type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiCreatePatientAdvisorChatSession', 'patient_id', patient_id)
            // verify required parameter 'AdvisorChatMessageRequest' is not null or undefined
            assertParamExists('appApiAdvisorChatApiCreatePatientAdvisorChatSession', 'AdvisorChatMessageRequest', AdvisorChatMessageRequest)
            const localVarPath = `/patients/{patient_id}/advisor-chat/sessions`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (session_type !== undefined) {
                localVarQueryParameter['session_type'] = session_type;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AdvisorChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get question suggestions in the advisor chat for the patient
         * @param {number} patient_id 
         * @param {string} [question_date] 
         * @param {boolean} [force_rebuild] 
         * @param {string} [subject_type] 
         * @param {string} [subject_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetAdvisorQuestionSuggestions: async (patient_id: number, question_date?: string, force_rebuild?: boolean, subject_type?: string, subject_id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetAdvisorQuestionSuggestions', 'patient_id', patient_id)
            const localVarPath = `/patients/{patient_id}/advisor-chat/question-suggestions`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (question_date !== undefined) {
                localVarQueryParameter['question_date'] = question_date;
            }

            if (force_rebuild !== undefined) {
                localVarQueryParameter['force_rebuild'] = force_rebuild;
            }

            if (subject_type !== undefined) {
                localVarQueryParameter['subject_type'] = subject_type;
            }

            if (subject_id !== undefined) {
                localVarQueryParameter['subject_id'] = subject_id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get advisor chat session for the patient
         * @param {number} patient_id 
         * @param {number} advisor_chat_session_id 
         * @param {number} [message_limit] 
         * @param {string} [message_next_timestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetPatientAdvisorChatSession: async (patient_id: number, advisor_chat_session_id: number, message_limit?: number, message_next_timestamp?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSession', 'patient_id', patient_id)
            // verify required parameter 'advisor_chat_session_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSession', 'advisor_chat_session_id', advisor_chat_session_id)
            const localVarPath = `/patients/{patient_id}/advisor-chat/sessions/{advisor_chat_session_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"advisor_chat_session_id"}}`, encodeURIComponent(String(advisor_chat_session_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (message_limit !== undefined) {
                localVarQueryParameter['message_limit'] = message_limit;
            }

            if (message_next_timestamp !== undefined) {
                localVarQueryParameter['message_next_timestamp'] = message_next_timestamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get advisor chat session for the patient
         * @param {number} patient_id 
         * @param {string} subject_type 
         * @param {string} subject_id 
         * @param {number} [message_limit] 
         * @param {string} [message_next_timestamp] 
         * @param {string} [session_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject: async (patient_id: number, subject_type: string, subject_id: string, message_limit?: number, message_next_timestamp?: string, session_type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject', 'patient_id', patient_id)
            // verify required parameter 'subject_type' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject', 'subject_type', subject_type)
            // verify required parameter 'subject_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject', 'subject_id', subject_id)
            const localVarPath = `/patients/{patient_id}/advisor-chat/sessions/subject/{subject_type}/{subject_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"subject_type"}}`, encodeURIComponent(String(subject_type)))
                .replace(`{${"subject_id"}}`, encodeURIComponent(String(subject_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (message_limit !== undefined) {
                localVarQueryParameter['message_limit'] = message_limit;
            }

            if (message_next_timestamp !== undefined) {
                localVarQueryParameter['message_next_timestamp'] = message_next_timestamp;
            }

            if (session_type !== undefined) {
                localVarQueryParameter['session_type'] = session_type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a message from the advisor chat session for the patient
         * @param {number} patient_id 
         * @param {number} advisor_chat_session_id 
         * @param {number} advisor_chat_message_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage: async (patient_id: number, advisor_chat_session_id: number, advisor_chat_message_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage', 'patient_id', patient_id)
            // verify required parameter 'advisor_chat_session_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage', 'advisor_chat_session_id', advisor_chat_session_id)
            // verify required parameter 'advisor_chat_message_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage', 'advisor_chat_message_id', advisor_chat_message_id)
            const localVarPath = `/patients/{patient_id}/advisor-chat/sessions/{advisor_chat_session_id}/messages/{advisor_chat_message_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"advisor_chat_session_id"}}`, encodeURIComponent(String(advisor_chat_session_id)))
                .replace(`{${"advisor_chat_message_id"}}`, encodeURIComponent(String(advisor_chat_message_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of advisor chat sessions for the patient
         * @param {number} patient_id 
         * @param {AdvisorChatSubjectTypeEnum} [subject_type] 
         * @param {number} [limit] 
         * @param {string} [next_timestamp] 
         * @param {string} [session_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetPatientAdvisorChatSessions: async (patient_id: number, subject_type?: AdvisorChatSubjectTypeEnum, limit?: number, next_timestamp?: string, session_type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiGetPatientAdvisorChatSessions', 'patient_id', patient_id)
            const localVarPath = `/patients/{patient_id}/advisor-chat/sessions`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (subject_type !== undefined) {
                localVarQueryParameter['subject_type'] = subject_type;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (next_timestamp !== undefined) {
                localVarQueryParameter['next_timestamp'] = next_timestamp;
            }

            if (session_type !== undefined) {
                localVarQueryParameter['session_type'] = session_type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a message to the advisor chat session and get a response
         * @param {number} patient_id 
         * @param {number} advisor_chat_session_id 
         * @param {AdvisorChatMessageRequest} AdvisorChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiPostPatientAdvisorChatMessage: async (patient_id: number, advisor_chat_session_id: number, AdvisorChatMessageRequest: AdvisorChatMessageRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiPostPatientAdvisorChatMessage', 'patient_id', patient_id)
            // verify required parameter 'advisor_chat_session_id' is not null or undefined
            assertParamExists('appApiAdvisorChatApiPostPatientAdvisorChatMessage', 'advisor_chat_session_id', advisor_chat_session_id)
            // verify required parameter 'AdvisorChatMessageRequest' is not null or undefined
            assertParamExists('appApiAdvisorChatApiPostPatientAdvisorChatMessage', 'AdvisorChatMessageRequest', AdvisorChatMessageRequest)
            const localVarPath = `/patients/{patient_id}/advisor-chat/sessions/{advisor_chat_session_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"advisor_chat_session_id"}}`, encodeURIComponent(String(advisor_chat_session_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(AdvisorChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvisorChatApi - functional programming interface
 * @export
 */
export const AdvisorChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdvisorChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new advisor chat session for the patient with an initial message
         * @param {number} patient_id 
         * @param {AdvisorChatMessageRequest} AdvisorChatMessageRequest 
         * @param {string} [session_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAdvisorChatApiCreatePatientAdvisorChatSession(patient_id: number, AdvisorChatMessageRequest: AdvisorChatMessageRequest, session_type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAdvisorChatApiCreatePatientAdvisorChatSession(patient_id, AdvisorChatMessageRequest, session_type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get question suggestions in the advisor chat for the patient
         * @param {number} patient_id 
         * @param {string} [question_date] 
         * @param {boolean} [force_rebuild] 
         * @param {string} [subject_type] 
         * @param {string} [subject_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAdvisorChatApiGetAdvisorQuestionSuggestions(patient_id: number, question_date?: string, force_rebuild?: boolean, subject_type?: string, subject_id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdvisorQuestionSuggestionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAdvisorChatApiGetAdvisorQuestionSuggestions(patient_id, question_date, force_rebuild, subject_type, subject_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get advisor chat session for the patient
         * @param {number} patient_id 
         * @param {number} advisor_chat_session_id 
         * @param {number} [message_limit] 
         * @param {string} [message_next_timestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAdvisorChatApiGetPatientAdvisorChatSession(patient_id: number, advisor_chat_session_id: number, message_limit?: number, message_next_timestamp?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorChatSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAdvisorChatApiGetPatientAdvisorChatSession(patient_id, advisor_chat_session_id, message_limit, message_next_timestamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get advisor chat session for the patient
         * @param {number} patient_id 
         * @param {string} subject_type 
         * @param {string} subject_id 
         * @param {number} [message_limit] 
         * @param {string} [message_next_timestamp] 
         * @param {string} [session_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject(patient_id: number, subject_type: string, subject_id: string, message_limit?: number, message_next_timestamp?: string, session_type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorChatSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject(patient_id, subject_type, subject_id, message_limit, message_next_timestamp, session_type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a message from the advisor chat session for the patient
         * @param {number} patient_id 
         * @param {number} advisor_chat_session_id 
         * @param {number} advisor_chat_message_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage(patient_id: number, advisor_chat_session_id: number, advisor_chat_message_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage(patient_id, advisor_chat_session_id, advisor_chat_message_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of advisor chat sessions for the patient
         * @param {number} patient_id 
         * @param {AdvisorChatSubjectTypeEnum} [subject_type] 
         * @param {number} [limit] 
         * @param {string} [next_timestamp] 
         * @param {string} [session_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAdvisorChatApiGetPatientAdvisorChatSessions(patient_id: number, subject_type?: AdvisorChatSubjectTypeEnum, limit?: number, next_timestamp?: string, session_type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorChatSessionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAdvisorChatApiGetPatientAdvisorChatSessions(patient_id, subject_type, limit, next_timestamp, session_type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send a message to the advisor chat session and get a response
         * @param {number} patient_id 
         * @param {number} advisor_chat_session_id 
         * @param {AdvisorChatMessageRequest} AdvisorChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiAdvisorChatApiPostPatientAdvisorChatMessage(patient_id: number, advisor_chat_session_id: number, AdvisorChatMessageRequest: AdvisorChatMessageRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorChatMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiAdvisorChatApiPostPatientAdvisorChatMessage(patient_id, advisor_chat_session_id, AdvisorChatMessageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdvisorChatApi - factory interface
 * @export
 */
export const AdvisorChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdvisorChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new advisor chat session for the patient with an initial message
         * @param {AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiCreatePatientAdvisorChatSession(requestParameters: AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSessionRequest, options?: AxiosRequestConfig): AxiosPromise<AdvisorChatMessageResponse> {
            return localVarFp.appApiAdvisorChatApiCreatePatientAdvisorChatSession(requestParameters.patient_id, requestParameters.AdvisorChatMessageRequest, requestParameters.session_type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get question suggestions in the advisor chat for the patient
         * @param {AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetAdvisorQuestionSuggestions(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestionsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AdvisorQuestionSuggestionResponse>> {
            return localVarFp.appApiAdvisorChatApiGetAdvisorQuestionSuggestions(requestParameters.patient_id, requestParameters.question_date, requestParameters.force_rebuild, requestParameters.subject_type, requestParameters.subject_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get advisor chat session for the patient
         * @param {AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetPatientAdvisorChatSession(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionRequest, options?: AxiosRequestConfig): AxiosPromise<AdvisorChatSessionResponse> {
            return localVarFp.appApiAdvisorChatApiGetPatientAdvisorChatSession(requestParameters.patient_id, requestParameters.advisor_chat_session_id, requestParameters.message_limit, requestParameters.message_next_timestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get advisor chat session for the patient
         * @param {AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubjectRequest, options?: AxiosRequestConfig): AxiosPromise<AdvisorChatSessionResponse> {
            return localVarFp.appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject(requestParameters.patient_id, requestParameters.subject_type, requestParameters.subject_id, requestParameters.message_limit, requestParameters.message_next_timestamp, requestParameters.session_type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a message from the advisor chat session for the patient
         * @param {AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessageRequest, options?: AxiosRequestConfig): AxiosPromise<AdvisorChatMessageResponse> {
            return localVarFp.appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage(requestParameters.patient_id, requestParameters.advisor_chat_session_id, requestParameters.advisor_chat_message_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of advisor chat sessions for the patient
         * @param {AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiGetPatientAdvisorChatSessions(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionsRequest, options?: AxiosRequestConfig): AxiosPromise<AdvisorChatSessionsResponse> {
            return localVarFp.appApiAdvisorChatApiGetPatientAdvisorChatSessions(requestParameters.patient_id, requestParameters.subject_type, requestParameters.limit, requestParameters.next_timestamp, requestParameters.session_type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a message to the advisor chat session and get a response
         * @param {AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiAdvisorChatApiPostPatientAdvisorChatMessage(requestParameters: AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessageRequest, options?: AxiosRequestConfig): AxiosPromise<AdvisorChatMessageResponse> {
            return localVarFp.appApiAdvisorChatApiPostPatientAdvisorChatMessage(requestParameters.patient_id, requestParameters.advisor_chat_session_id, requestParameters.AdvisorChatMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appApiAdvisorChatApiCreatePatientAdvisorChatSession operation in AdvisorChatApi.
 * @export
 * @interface AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSessionRequest
 */
export interface AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSessionRequest {
    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSession
     */
    readonly patient_id: number

    /**
     * 
     * @type {AdvisorChatMessageRequest}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSession
     */
    readonly AdvisorChatMessageRequest: AdvisorChatMessageRequest

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSession
     */
    readonly session_type?: string
}

/**
 * Request parameters for appApiAdvisorChatApiGetAdvisorQuestionSuggestions operation in AdvisorChatApi.
 * @export
 * @interface AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestionsRequest
 */
export interface AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestionsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestions
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestions
     */
    readonly question_date?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestions
     */
    readonly force_rebuild?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestions
     */
    readonly subject_type?: string

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestions
     */
    readonly subject_id?: string
}

/**
 * Request parameters for appApiAdvisorChatApiGetPatientAdvisorChatSession operation in AdvisorChatApi.
 * @export
 * @interface AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionRequest
 */
export interface AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionRequest {
    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSession
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSession
     */
    readonly advisor_chat_session_id: number

    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSession
     */
    readonly message_limit?: number

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSession
     */
    readonly message_next_timestamp?: string
}

/**
 * Request parameters for appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject operation in AdvisorChatApi.
 * @export
 * @interface AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubjectRequest
 */
export interface AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubjectRequest {
    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject
     */
    readonly subject_type: string

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject
     */
    readonly subject_id: string

    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject
     */
    readonly message_limit?: number

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject
     */
    readonly message_next_timestamp?: string

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject
     */
    readonly session_type?: string
}

/**
 * Request parameters for appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage operation in AdvisorChatApi.
 * @export
 * @interface AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessageRequest
 */
export interface AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessageRequest {
    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessage
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessage
     */
    readonly advisor_chat_session_id: number

    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessage
     */
    readonly advisor_chat_message_id: number
}

/**
 * Request parameters for appApiAdvisorChatApiGetPatientAdvisorChatSessions operation in AdvisorChatApi.
 * @export
 * @interface AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionsRequest
 */
export interface AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessions
     */
    readonly patient_id: number

    /**
     * 
     * @type {AdvisorChatSubjectTypeEnum}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessions
     */
    readonly subject_type?: AdvisorChatSubjectTypeEnum

    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessions
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessions
     */
    readonly next_timestamp?: string

    /**
     * 
     * @type {string}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessions
     */
    readonly session_type?: string
}

/**
 * Request parameters for appApiAdvisorChatApiPostPatientAdvisorChatMessage operation in AdvisorChatApi.
 * @export
 * @interface AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessageRequest
 */
export interface AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessageRequest {
    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessage
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessage
     */
    readonly advisor_chat_session_id: number

    /**
     * 
     * @type {AdvisorChatMessageRequest}
     * @memberof AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessage
     */
    readonly AdvisorChatMessageRequest: AdvisorChatMessageRequest
}

/**
 * AdvisorChatApi - object-oriented interface
 * @export
 * @class AdvisorChatApi
 * @extends {BaseAPI}
 */
export class AdvisorChatApi extends BaseAPI {
    /**
     * 
     * @summary Create a new advisor chat session for the patient with an initial message
     * @param {AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorChatApi
     */
    public appApiAdvisorChatApiCreatePatientAdvisorChatSession(requestParameters: AdvisorChatApiAppApiAdvisorChatApiCreatePatientAdvisorChatSessionRequest, options?: AxiosRequestConfig) {
        return AdvisorChatApiFp(this.configuration).appApiAdvisorChatApiCreatePatientAdvisorChatSession(requestParameters.patient_id, requestParameters.AdvisorChatMessageRequest, requestParameters.session_type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get question suggestions in the advisor chat for the patient
     * @param {AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorChatApi
     */
    public appApiAdvisorChatApiGetAdvisorQuestionSuggestions(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetAdvisorQuestionSuggestionsRequest, options?: AxiosRequestConfig) {
        return AdvisorChatApiFp(this.configuration).appApiAdvisorChatApiGetAdvisorQuestionSuggestions(requestParameters.patient_id, requestParameters.question_date, requestParameters.force_rebuild, requestParameters.subject_type, requestParameters.subject_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get advisor chat session for the patient
     * @param {AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorChatApi
     */
    public appApiAdvisorChatApiGetPatientAdvisorChatSession(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionRequest, options?: AxiosRequestConfig) {
        return AdvisorChatApiFp(this.configuration).appApiAdvisorChatApiGetPatientAdvisorChatSession(requestParameters.patient_id, requestParameters.advisor_chat_session_id, requestParameters.message_limit, requestParameters.message_next_timestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get advisor chat session for the patient
     * @param {AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorChatApi
     */
    public appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionBySubjectRequest, options?: AxiosRequestConfig) {
        return AdvisorChatApiFp(this.configuration).appApiAdvisorChatApiGetPatientAdvisorChatSessionBySubject(requestParameters.patient_id, requestParameters.subject_type, requestParameters.subject_id, requestParameters.message_limit, requestParameters.message_next_timestamp, requestParameters.session_type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a message from the advisor chat session for the patient
     * @param {AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorChatApi
     */
    public appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionMessageRequest, options?: AxiosRequestConfig) {
        return AdvisorChatApiFp(this.configuration).appApiAdvisorChatApiGetPatientAdvisorChatSessionMessage(requestParameters.patient_id, requestParameters.advisor_chat_session_id, requestParameters.advisor_chat_message_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of advisor chat sessions for the patient
     * @param {AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorChatApi
     */
    public appApiAdvisorChatApiGetPatientAdvisorChatSessions(requestParameters: AdvisorChatApiAppApiAdvisorChatApiGetPatientAdvisorChatSessionsRequest, options?: AxiosRequestConfig) {
        return AdvisorChatApiFp(this.configuration).appApiAdvisorChatApiGetPatientAdvisorChatSessions(requestParameters.patient_id, requestParameters.subject_type, requestParameters.limit, requestParameters.next_timestamp, requestParameters.session_type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a message to the advisor chat session and get a response
     * @param {AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorChatApi
     */
    public appApiAdvisorChatApiPostPatientAdvisorChatMessage(requestParameters: AdvisorChatApiAppApiAdvisorChatApiPostPatientAdvisorChatMessageRequest, options?: AxiosRequestConfig) {
        return AdvisorChatApiFp(this.configuration).appApiAdvisorChatApiPostPatientAdvisorChatMessage(requestParameters.patient_id, requestParameters.advisor_chat_session_id, requestParameters.AdvisorChatMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

